<template>
  <div class="page-block">
    <header-bar v-if="isLoggedIn">ヘルプ</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">
        お問い合わせ
      </h3>
    </div>
    <div class="page-block__inner">
      <div
        v-if="isBtoB"
        class="form-complete-area">
        <div class="form-complete-area__title">
          お問い合わせありがとうございます
        </div>
        <div
          class="form-complete-area__lead">
          この度は、お問い合わせをいただき、誠にありがとうございました。
          <br class="pc">
          お送りいただきました内容を確認の上、ご返信させていただきます。
          <br>通常、2〜3営業日中にはご返信を差し上げるようにしておりますが、3営業日を経過しても連絡がない場合は、<br class="pc">
          下記の連絡先までお問い合わせくださいませ。
        </div>
        <div class="form-complete-area__text">
          お問い合わせ先<br>
          <a
            href="mailto:support@zula.jp">
            support@zula.jp
          </a>
        </div>
        <div class="form-complete-area__text">
          また、ご記入いただきましたメールアドレスへ、自動返信の確認メールを送付しています。
          <br>万が一、自動返信メールが届かない場合は、入力いただいたメールアドレスに間違いがあった可能性がございます。
          <br>メールアドレスをご確認の上、もう一度フォームよりお問い合わせ頂けますようお願い申し上げます。
        </div>
      </div>
      <div
        v-else
        class="form-complete-area">
        <div class="form-complete-area__title">
          お問い合わせありがとうございます
        </div>
        <div
          v-if="is_replyable"
          class="form-complete-area__lead">
          お送りいただきました内容を確認の上、返信いたします。<br>
          内容によっては返信にお時間をいただく場合もございますので、ご了承ください。<br><br>
          なお、ご入力をいただきましたメールアドレスへ、受付完了メールを自動送信しております。<br>
          万が一、自動送信メールが届かない場合は、ご入力いただいたメールアドレスに間違いがあった可能性がございます。<br>
          メールアドレスをご確認の上、再度フォームよりお問い合わせをお願いいたします。<br>
        </div>
        <div
          v-else
          class="form-complete-area__lead">
          各配信ストアでの情報反映には、数週間から数ヶ月掛かる場合がございます。<br>
          各種変更の反映をお待ちください。<br><br>
          なお、ご入力をいただきましたメールアドレスへ、受付完了メールを自動送信しております。<br>
          万が一、自動送信メールが届かない場合は、ご入力いただいたメールアドレスに間違いがあった可能性がございます。<br>
          メールアドレスをご確認の上、再度フォームよりお問い合わせをお願いいたします。<br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  name: 'ContactComplete',
  components: { HeaderBar },
  data() {
    return {
      is_replyable: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
  mounted() {
    this.is_replyable = window.sessionStorage.getItem('is_replyable') !== 'false'
  },
}
</script>

<style scoped>
</style>
